module.exports = __webpack_public_path__ + "static/media/15UN-Habitat1.0b75805e.jpg";